let BASE_URL = '/saas-biz-service/manager/permission'
const TIME_OUT = 60000
export { BASE_URL, TIME_OUT }
